export default {
  getToken() {
    return fetch("/session/token?t=" + Date.now(), {
      credentials: "include"
    })
    .then(response => {
      return response.text();
    });
  },
}
